// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CarryOutOutlinedSvg from "@fishx/icons-svg/es/asn/CarryOutOutlined";
import FishxIcon from '../components/FishxIcon';

var CarryOutOutlined = function CarryOutOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CarryOutOutlinedSvg
  }));
};

CarryOutOutlined.displayName = 'CarryOutOutlined';
export default React.forwardRef(CarryOutOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CarryOutOutlined.js
// module id = 2186
// module chunks = 0